import Switch from '../../Atoms/Form/Elements/Switch'
import TextLink from '../../Atoms/TextLink/TextLink'
import styles from './Feedback.module.scss'

import { useMemo } from 'react'

import Form from 'Atoms/Form'

const ContactSwitch = ({ contactOkay, setContactOkay }) => (
  <div className={styles.switch}>
    <Switch id="contactOkaySwitch" brand="primary" checked={contactOkay} onChange={setContactOkay} />
    <p className="p p-0_875 p-color-subtle">It's okay to contact me about this</p>
  </div>
)

const SuggestionCheckbox = ({ show, toggle, label }) => (
  <div className={styles.checkboxContainer}>
    <Form.CheckboxGroup
      options={useMemo(
        () => [
          {
            label: label,
            checked: show,
            onChange: toggle,
          },
        ],
        [label, show, toggle],
      )}
      noTransition
      size={0.875}
    />
  </div>
)

const ContactEmailInput = ({ email, onEmailChange, id }) => (
  <Form.Textbox
    label={'Enter your Email'}
    className={styles.textArea}
    fill
    onChange={onEmailChange}
    brand="primary"
    id={id}
    type="email"
    value={email}
    size={0.875}
    placeholder="you@example.com"
  />
)

const HelpText = () => (
  <p className="p p-color-subtle p-0_875">
    If you need assistance, please{' '}
    <TextLink size={0.875} intent="action" href="/info/helpcenter">
      contact us
    </TextLink>
  </p>
)

export { HelpText, ContactEmailInput, SuggestionCheckbox, ContactSwitch }
